var _toConsumableArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;
var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass.js").default;
var _assertThisInitialized = require("/vercel/path0/node_modules/@babel/runtime/helpers/assertThisInitialized.js").default;
var _inherits = require("/vercel/path0/node_modules/@babel/runtime/helpers/inherits.js").default;
var _createSuper = require("/vercel/path0/node_modules/@babel/runtime/helpers/createSuper.js").default;
var _wrapNativeSuper = require("/vercel/path0/node_modules/@babel/runtime/helpers/wrapNativeSuper.js").default;
var _require = require('eth-util-lite'),
  encode = _require.encode,
  toHex = _require.toHex;
var EthObject = /*#__PURE__*/function (_Array) {
  "use strict";

  _inherits(EthObject, _Array);
  var _super = _createSuper(EthObject);
  function EthObject(fields, raw) {
    var _this;
    _classCallCheck(this, EthObject);
    //raw array
    _this = _super.call.apply(_super, [this].concat(_toConsumableArray(raw)));

    // properties
    fields.forEach(function (field, i) {
      Object.defineProperty(_assertThisInitialized(_this), field, {
        value: _this[i],
        writable: false
      });
    });
    Object.defineProperty(_assertThisInitialized(_this), 'fields', {
      value: fields,
      writable: false
    });

    // methods
    Object.defineProperty(_assertThisInitialized(_this), 'buffer', {
      get: function get() {
        return encode(this.raw);
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), 'hex', {
      get: function get() {
        return toHex(this.buffer);
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), 'raw', {
      get: function get() {
        var _this2 = this;
        return this.fields.map(function (field, i) {
          return _this2[i];
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), 'object', {
      get: function get() {
        var _this3 = this;
        var obj = {};
        this.fields.forEach(function (field, index) {
          if (_this3[index] instanceof Array) {
            obj[field] = _this3[index];
          } else {
            obj[field] = toHex(_this3[index]);
          }
        });
        return obj;
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), 'json', {
      get: function get() {
        return JSON.stringify(this.object);
      }
    });
    return _this;
  }

  // aliases
  _createClass(EthObject, [{
    key: "serialize",
    value: function serialize() {
      return this.buffer;
    }
  }, {
    key: "toBuffer",
    value: function toBuffer() {
      return this.buffer;
    }
  }, {
    key: "toHex",
    value: function toHex() {
      return this.hex;
    }
  }, {
    key: "toObject",
    value: function toObject() {
      return this.object;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.json;
    }
  }, {
    key: "toJson",
    value: function toJson() {
      return this.json;
    }
  }]);
  return EthObject;
}( /*#__PURE__*/_wrapNativeSuper(Array));
module.exports = EthObject;